import type { AxiosResponse } from 'axios'
import { getExtraQuestionsUrl } from '../../../constants/ccAppServiceUri'
import { ApiCCApp } from '../api/endpoints'

export interface ExtraQuestion {
  question: string
  answer: string
}

export interface SubmitExtraQuestionsBody {
  extraQuestions: ExtraQuestion[]
}

export interface SubmitExtraQuestionsProps {
  applicationId: string
  body: SubmitExtraQuestionsBody
}

const submitExtraQuestions = async ({
  applicationId,
  body,
}: SubmitExtraQuestionsProps): Promise<AxiosResponse> => {
  const url = getExtraQuestionsUrl(applicationId)

  return ApiCCApp.post<SubmitExtraQuestionsBody, AxiosResponse>(url, body)
}

export default submitExtraQuestions
